export default "__VITE_ASSET__BlSCK2_M__";